/**
 * `GmsScreen` — the shared GMS//OS backdrop the pre-auth surfaces sit on:
 * the `.gms-os` root (dim GMS bg + Archivo/JetBrains Mono fonts), the box-drawing GMS
 * wallpaper + tagline, and the edge vignette. The `/login` terminal and the pilot picker render
 * through this, and the shell's narrative stage draws the same wallpaper, so they read as the
 * *same* booting machine — the diegetic Omnihook.
 *
 * Children render over the wallpaper (vignette z 5).
 */
import type { ReactNode } from "react";
import "./gms-desktop.css";

/** The GMS box-drawing wordmark that fills the wallpaper. */
export const GMS_ASCII = ` ██████╗ ███╗   ███╗███████╗
██╔════╝ ████╗ ████║██╔════╝
██║  ███╗██╔████╔██║███████╗
██║   ██║██║╚██╔╝██║╚════██║
╚██████╔╝██║ ╚═╝ ██║███████║
 ╚═════╝ ╚═╝     ╚═╝╚══════╝`;

export function GmsScreen({ children }: { children: ReactNode }) {
  return (
    <div className="gms-os">
      {/* wallpaper */}
      <pre className="gms-wallpaper">{GMS_ASCII}</pre>
      <div className="gms-tagline">GENERAL MASSIVE SYSTEMS</div>
      <div className="gms-vignette" />

      {children}
    </div>
  );
}
